/**
 * Extract the weblab ID (part before the colon) from a text string.
 * Weblab format: WEBLAB_ID:TREATMENT where TREATMENT is C or T1, T2, etc.
 * Returns null if no weblab is found.
 */
export function extractWeblabId(text: string): string | null {
  const match = text.match(/\b([A-Z][A-Z0-9_]{3,})\s*:\s*(?:T\d+|C)\b/);
  if (match && !match[1].match(/^B[0-9A-Z]{9}$/)) {
    return match[1];
  }
  return null;
}

/**
 * Validate that a new message's weblab ID is compatible with the session's existing weblab ID.
 * Returns an error message if incompatible, or null if OK.
 */
export function validateWeblabForSession(
  messageText: string,
  sessionWeblabId: string | null
): string | null {
  const newWeblabId = extractWeblabId(messageText);
  if (!newWeblabId || !sessionWeblabId) return null;
  if (newWeblabId !== sessionWeblabId) {
    return `This session is already using weblab "${sessionWeblabId}". You cannot mix weblabs in the same session. Please open a new tab for weblab "${newWeblabId}".`;
  }
  return null;
}
